import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ToursHero() {
  const { t } = useTranslation();
  return (
    <section className="relative w-full min-h-[420px] md:min-h-[520px] flex items-center justify-center overflow-hidden pt-20">
      <img
        src="https://readdy.ai/api/search-image?query=Vibrant%20Vietnamese%20floating%20market%20on%20Mekong%20Delta%20with%20colorful%20boats%20laden%20with%20tropical%20fruits%20and%20flowers%2C%20local%20vendors%20in%20conical%20hats%2C%20warm%20golden%20morning%20light%20reflecting%20on%20water%2C%20lush%20palm%20trees%20along%20riverbank%2C%20authentic%20Southeast%20Asian%20travel%20scene%2C%20rich%20saturated%20colors&width=1600&height=900&seq=tours-hero&orientation=landscape"
        alt={t('tours.heroAlt')}
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60" />

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 text-center">
        <p className="text-accent-400 text-sm md:text-base tracking-wide uppercase mb-3">
          {t('tours.heroEyebrow')}
        </p>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4">
          {t('tours.heroTitle')}
        </h1>
        <p className="text-white/80 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
          {t('tours.heroSubtitle')}
        </p>

        <nav className="mt-8 flex items-center justify-center gap-2 text-sm text-white/70">
          <Link to="/" className="hover:text-white transition-colors">{t('tours.breadcrumbHome')}</Link>
          <span>/</span>
          <span className="text-white">{t('tours.heroTitle')}</span>
        </nav>
      </div>
    </section>
  );
}